import React from 'react';
import StopIcon from '@material-ui/icons/Stop';
import Divider from '@material-ui/core/Divider';
import Box from '@material-ui/core/Box';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  ornament: {
    'display': 'flex',
    'marginBottom': theme.spacing(1),
    marginLeft: -8,
    '& hr': {
      backgroundColor: theme.palette.primary.main,
      flex: 1,
      marginTop: 8,
    },
  },
}));

const CustomDivider = () => {
  const classes = useStyles();

  return (
    <Box className={classes.ornament}>
      <StopIcon color="primary" />
      <Divider />
    </Box>
  );
}

export default CustomDivider;